
<template>
  <AppTemplate>
    <!--template #title>Tableau de bord</template-->
    <div class="dashboard-container">
      <h2 class="mb-4">Tableau de bord</h2>
      
      <!-- Cartes statistiques -->
      <div class="row mb-4">
        <div class="col-md-3 mb-3" v-for="stat in stats" :key="stat.title">
          <div class="card stat-card h-100">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="card-subtitle mb-2 text-muted">{{ stat.title }}</h6>
                  <h3 class="card-title">{{ stat.value }}</h3>
                </div>
                <div class="icon-circle" :class="stat.bgClass">
                  <i :class="stat.icon"></i>
                </div>
              </div>
              <p class="card-text text-muted small mt-2">
                <i class="fas" :class="stat.trendIcon"></i> {{ stat.trend }} depuis le mois dernier
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Graphiques -->
      <div class="row">
        <div class="col-md-6 mb-4">
          <div class="card h-100">
            <div class="card-body">
              <h5 class="card-title">Inscriptions par mois</h5>
              <canvas ref="usersChart"></canvas>
            </div>
          </div>
        </div>
        
        <div class="col-md-6 mb-4">
          <div class="card h-100">
            <div class="card-body">
              <h5 class="card-title">Projets créés par mois</h5>
              <canvas ref="projectsChart"></canvas>
            </div>
          </div>
        </div>
      </div>

      <!-- Section des graphiques de répartition -->
      <div class="row mt-4">
        <div class="col-md-6 mb-4">
          <CountryDistributionChart />
        </div>
        <div class="col-md-6 mb-4">
          <ExperienceDistributionChart />
        </div>
      </div>

    </div>
  </AppTemplate>
</template>

<script>
import CountryDistributionChart from '@/components/CountryDistributionChart.vue'
import ExperienceDistributionChart from '@/components/ExperienceDistributionChart.vue'
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

export default {
  name: 'HomeView',
  components: {
    CountryDistributionChart,
    ExperienceDistributionChart
  },
  data() {
    return {
      stats: [
        {
          title: 'Freelances',
          value: 0,
          icon: 'fas fa-code',
          bgClass: 'bg-primary',
          trend: '+12%',
          trendIcon: 'fa-arrow-up text-success'
        },
        {
          title: 'Clients',
          value: 0,
          icon: 'fas fa-user-tie',
          bgClass: 'bg-success',
          trend: '+5%',
          trendIcon: 'fa-arrow-up text-success'
        },
        {
          title: 'Projets ce mois',
          value: 0,
          icon: 'fas fa-project-diagram',
          bgClass: 'bg-warning',
          trend: '+18%',
          trendIcon: 'fa-arrow-up text-success'
        },
        {
          title: 'Contacts',
          value: 0,
          icon: 'fas fa-envelope',
          bgClass: 'bg-info',
          trend: '-3%',
          trendIcon: 'fa-arrow-down text-danger'
        }
      ],
      usersChart: null,
      projectsChart: null
    }
  },
  mounted() {
    this.fetchStats();
    this.fetchCharts();
  },
  beforeUnmount() {
    if (this.usersChart) this.usersChart.destroy();
    if (this.projectsChart) this.projectsChart.destroy();
  },
  methods: {
    async fetchStats() {
      try {
        const response = await this.axios.get('/api/stats');
        this.stats[0].value = response.data.freelances;
        this.stats[1].value = response.data.clients;
        this.stats[2].value = response.data.projectsThisMonth;
        this.stats[3].value = response.data.contacts;
      } catch (error) {
        console.error('Error fetching stats:', error);
      }
    },
    async fetchCharts() {
      try {
        const response = await this.axios.get('/api/stats/charts');
        
        // Graphique des utilisateurs
        this.usersChart = new Chart(this.$refs.usersChart, {
          type: 'bar',
          data: {
            labels: response.data.months,
            datasets: [{
              label: 'Inscriptions',
              data: response.data.users,
              backgroundColor: 'rgba(54, 162, 235, 0.5)',
              borderColor: 'rgba(54, 162, 235, 1)',
              borderWidth: 1
            }]
          },
          options: {
            responsive: true,
            scales: {
              y: {
                beginAtZero: true
              }
            }
          }
        });
        
        // Graphique des projets
        this.projectsChart = new Chart(this.$refs.projectsChart, {
          type: 'line',
          data: {
            labels: response.data.months,
            datasets: [{
              label: 'Projets',
              data: response.data.projects,
              backgroundColor: 'rgba(255, 159, 64, 0.2)',
              borderColor: 'rgba(255, 159, 64, 1)',
              borderWidth: 2,
              tension: 0.1,
              fill: true
            }]
          },
          options: {
            responsive: true,
            scales: {
              y: {
                beginAtZero: true
              }
            }
          }
        });
        
      } catch (error) {
        console.error('Error fetching charts:', error);
      }
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  padding: 20px;
}

.stat-card {
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
}

.icon-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.25rem;
}

.bg-primary { background-color: #4e73df; }
.bg-success { background-color: #1cc88a; }
.bg-warning { background-color: #f6c23e; }
.bg-info { background-color: #36b9cc; }
</style>